<div class="container-fluid receipt-new-page">
  <div class="row">
    <!-- Left Column - Input Form -->
    <div class="col-md-5">
      <div class="card mb-3">
        <div class="card-header">
          <h5 class="mb-0"><i class="fas fa-receipt mr-2"></i>New Receipt</h5>
        </div>
        <div class="card-body">
          <!-- Payor Selection -->
          <div class="form-group">
            <label class="font-weight-bold">Payor:</label>
            <div *ngIf="!payorId" class="input-group">
              <input type="text"
                     class="form-control"
                     placeholder="Search for contact..."
                     [(ngModel)]="contactSearchTerm"
                     (input)="searchContacts(contactSearchTerm)"
                     [disabled]="loading">
              <div class="input-group-append" *ngIf="isSearchingContact">
                <span class="input-group-text">
                  <i class="fas fa-spinner fa-spin"></i>
                </span>
              </div>
            </div>
            <div *ngIf="contactSearchResults.length > 0" class="search-results">
              <div *ngFor="let contact of contactSearchResults"
                   class="search-result-item"
                   (click)="selectContact(contact)">
                {{ contact.label || contact.name }}
              </div>
            </div>
            <div *ngIf="payorId" class="selected-item">
              <span class="badge badge-primary mr-2">{{ payorName }}</span>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearPayor()">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- Payment Method -->
          <div class="form-group">
            <label class="font-weight-bold">Payment Method:</label>
            <select class="form-control"
                    [(ngModel)]="paymentMethodId"
                    (change)="onPaymentMethodChange()"
                    [disabled]="loading">
              <option [ngValue]="null">-- Select --</option>
              <option *ngFor="let pm of paymentMethods" [ngValue]="pm.id">
                {{ pm.name }}
              </option>
            </select>
          </div>

          <!-- Amount -->
          <div class="form-group">
            <label class="font-weight-bold">Amount:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input type="number"
                     class="form-control"
                     [(ngModel)]="amount"
                     step="0.01"
                     min="0"
                     [disabled]="loading">
            </div>
          </div>
        </div>
      </div>

      <!-- Matter Selection (shown when ready to allocate) -->
      <div class="card mb-3" *ngIf="canAddAllocation() && !currentAllocation.matterId">
        <div class="card-header">
          <h6 class="mb-0">Select Matter</h6>
        </div>
        <div class="card-body">
          <!-- Matters from contact -->
          <div *ngIf="matters.length > 0" class="matter-list mb-3">
            <div *ngFor="let matter of matters" class="matter-item d-flex align-items-center mb-2">
              <button type="button" class="btn btn-sm btn-primary mr-2" (click)="selectMatter(matter)">
                Select
              </button>
              <span>{{ matter[2] }} - {{ matter[1] }}</span>
            </div>
          </div>

          <!-- Matter search -->
          <div class="form-group">
            <label class="small text-muted">Or search for a matter:</label>
            <input type="text"
                   class="form-control form-control-sm"
                   placeholder="Search matters..."
                   [(ngModel)]="matterSearchTerm"
                   (input)="searchMatters(matterSearchTerm)">
            <div *ngIf="matterSearchResults.length > 0" class="search-results">
              <div *ngFor="let matter of matterSearchResults"
                   class="search-result-item"
                   (click)="selectMatterFromSearch(matter)">
                {{ matter.label || matter.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Allocation Form (shown when matter is selected) -->
      <div class="card mb-3" *ngIf="canAddAllocation() && currentAllocation.matterId">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h6 class="mb-0">Allocate to: {{ currentAllocation.matterNumber }}</h6>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearAllocation()">
            <i class="fas fa-times"></i> Cancel
          </button>
        </div>
        <div class="card-body">
          <div class="text-center mb-2">
            <small class="text-muted">{{ currentAllocation.matterName }}</small>
          </div>

          <!-- Apply To -->
          <div class="form-group">
            <label class="font-weight-bold">Apply To:</label>
            <select class="form-control"
                    [(ngModel)]="currentAllocation.applyTo"
                    (change)="onApplyToChange()">
              <option value="">-- Select --</option>
              <option *ngFor="let applyTo of applyTos" [value]="applyTo">
                {{ applyTo }}
              </option>
            </select>
          </div>

          <!-- Expense Selection (shown when Apply To is Expense) -->
          <div class="form-group" *ngIf="currentAllocation.applyTo === 'Expense'">
            <label class="font-weight-bold">Select Expense:</label>
            <select class="form-control"
                    [(ngModel)]="currentAllocation.expense"
                    (change)="onExpenseChange()">
              <option [ngValue]="null">-- Select --</option>
              <option *ngFor="let exp of expenses | keyvalue" [value]="exp.key">
                {{ exp.value.description }}
              </option>
            </select>
          </div>

          <!-- Allocation Amount -->
          <div class="form-group">
            <label class="font-weight-bold">Amount:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input type="number"
                     class="form-control"
                     [(ngModel)]="currentAllocation.amount"
                     step="0.01"
                     min="0"
                     [max]="max"
                     [disabled]="currentAllocation.applyTo === 'Expense'">
            </div>
          </div>

          <!-- Accept/Cancel Buttons -->
          <div class="text-center">
            <button type="button"
                    class="btn btn-primary mr-2"
                    [disabled]="!canAcceptAllocation()"
                    (click)="addAllocation()">
              <i class="fas fa-check mr-1"></i>Accept
            </button>
            <button type="button"
                    class="btn btn-secondary"
                    (click)="clearAllocation()">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- Save/Cancel -->
      <div class="card" *ngIf="allocations.length > 0">
        <div class="card-body text-center">
          <div *ngIf="!isFullyAllocated()" class="alert alert-warning mb-3">
            <i class="fas fa-exclamation-triangle mr-1"></i>
            Full amount must be allocated before saving. Remaining: {{ getBalance() | currency }}
          </div>
          <button type="button"
                  class="btn mr-2"
                  [class.btn-success]="canSave()"
                  [class.btn-secondary]="!canSave()"
                  [disabled]="!canSave()"
                  (click)="saveTransaction()">
            <i class="fas fa-save mr-1"></i>
            <span *ngIf="!saving">Save Transaction</span>
            <span *ngIf="saving"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
          </button>
          <button type="button"
                  class="btn btn-secondary"
                  (click)="cancelTransaction()">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Right Column - Summary -->
    <div class="col-md-7">
      <!-- Matter Balance Summary (shown when matter is selected) -->
      <div class="card mb-3" *ngIf="currentAllocation.matterId">
        <div class="card-header">
          <h6 class="mb-0">Matter Balance: {{ currentAllocation.matterNumber }}</h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <table class="table table-sm table-borderless">
                <tbody>
                  <tr>
                    <td>Charges</td>
                    <td class="text-right" [class.text-danger]="balances.Charges < 0">
                      {{ balances.Charges | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Payments</td>
                    <td class="text-right" [class.text-danger]="balances.Payments < 0">
                      {{ balances.Payments | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Credits</td>
                    <td class="text-right" [class.text-danger]="balances['Fee Credits'] < 0">
                      {{ balances['Fee Credits'] | currency }}
                    </td>
                  </tr>
                  <tr class="border-top">
                    <td><strong>Fee Total</strong></td>
                    <td class="text-right" [class.text-danger]="balances['Fee Total'] < 0">
                      <strong>{{ balances['Fee Total'] | currency }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-6">
              <table class="table table-sm table-borderless">
                <tbody>
                  <tr>
                    <td>Expenses</td>
                    <td class="text-right" [class.text-danger]="balances.Expenses < 0">
                      {{ balances.Expenses | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Expense Payments</td>
                    <td class="text-right" [class.text-danger]="balances['Expense Payments'] < 0">
                      {{ balances['Expense Payments'] | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Expense Credits</td>
                    <td class="text-right" [class.text-danger]="balances['Expense Credits'] < 0">
                      {{ balances['Expense Credits'] | currency }}
                    </td>
                  </tr>
                  <tr class="border-top">
                    <td><strong>Expense Total</strong></td>
                    <td class="text-right" [class.text-danger]="balances['Expense Total'] < 0">
                      <strong>{{ balances['Expense Total'] | currency }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <table class="table table-sm table-borderless">
                <thead>
                  <tr>
                    <th colspan="2" class="text-center border-bottom">Escrow Balances</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Escrow Fee</td>
                    <td class="text-right" [class.text-danger]="balances['Escrow Fee'] < 0">
                      {{ balances['Escrow Fee'] | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Escrow Costs</td>
                    <td class="text-right" [class.text-danger]="balances['Escrow Costs'] < 0">
                      {{ balances['Escrow Costs'] | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>Escrow Other</td>
                    <td class="text-right" [class.text-danger]="balances['Escrow Other'] < 0">
                      {{ balances['Escrow Other'] | currency }}
                    </td>
                  </tr>
                  <tr class="border-top">
                    <td><strong>Escrow Total</strong></td>
                    <td class="text-right" [class.text-danger]="balances.Escrow < 0">
                      <strong>{{ balances.Escrow | currency }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Balance Due -->
          <div class="row mt-3" *ngIf="heading">
            <div class="col-12 text-center">
              <h5>{{ heading }}: <span [class.text-danger]="due < 0">{{ due | currency }}</span></h5>
            </div>
          </div>

          <!-- Referral -->
          <div class="row mt-2" *ngIf="referral">
            <div class="col-12 text-center text-muted">
              Referral paid to: {{ referral }}
            </div>
          </div>

          <!-- Workers' Compensation -->
          <div *ngIf="wcStatus" class="mt-3 p-3 bg-light rounded">
            <h6 class="text-center">Workers' Compensation</h6>
            <table class="table table-sm table-borderless mb-0">
              <tbody>
                <tr>
                  <td>Outstanding</td>
                  <td class="text-right">
                    <span *ngIf="isNumber(wcStatus.Outstanding)">{{ wcStatus.Outstanding | currency }}</span>
                    <span *ngIf="!isNumber(wcStatus.Outstanding)">{{ wcStatus.Outstanding }}</span>
                  </td>
                </tr>
                <tr>
                  <td>Paid Until</td>
                  <td class="text-right">{{ wcStatus['Paid Until'] }}</td>
                </tr>
                <tr>
                  <td>Weekly Rate</td>
                  <td class="text-right">
                    <span *ngIf="isNumber(wcStatus['Weekly Rate'])">{{ wcStatus['Weekly Rate'] | currency }}</span>
                    <span *ngIf="!isNumber(wcStatus['Weekly Rate'])">{{ wcStatus['Weekly Rate'] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Receipt Summary -->
      <div class="card mb-3" *ngIf="amount > 0">
        <div class="card-header">
          <h6 class="mb-0">Receipt Summary</h6>
        </div>
        <div class="card-body">
          <table class="table table-sm">
            <tbody>
              <tr>
                <td>Receipt Amount</td>
                <td class="text-right" [class.text-danger]="amount < 0">
                  {{ amount | currency }}
                </td>
              </tr>
              <tr>
                <td>Allocated</td>
                <td class="text-right text-danger">
                  {{ (consumed * -1) | currency }}
                </td>
              </tr>
              <tr class="border-top">
                <td><strong>Balance</strong></td>
                <td class="text-right" [class.text-danger]="getBalance() < 0">
                  <strong>{{ getBalance() | currency }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Allocations List -->
      <div class="card mb-3" *ngIf="allocations.length > 0">
        <div class="card-header">
          <h6 class="mb-0">Allocations</h6>
        </div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
              <tr>
                <th></th>
                <th>Matter</th>
                <th class="text-right">Amount</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let allocation of allocations; let i = index">
                <td>
                  <button type="button"
                          class="btn btn-sm btn-link text-danger p-0"
                          (click)="deleteAllocation(i)"
                          title="Remove allocation">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
                <td>{{ allocation[3] }}</td>
                <td class="text-right" [class.text-danger]="allocation[1] < 0">
                  {{ allocation[1] | currency }}
                </td>
                <td>{{ allocation[2] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Scan Preview -->
      <div class="card" *ngIf="scanPreviewUrl">
        <div class="card-header">
          <h6 class="mb-0">Document Preview</h6>
        </div>
        <div class="card-body text-center">
          <img *ngIf="!scanPreviewError"
               [src]="scanPreviewUrl"
               class="img-fluid"
               style="max-width: 400px;"
               (error)="scanPreviewError = true">
          <div *ngIf="scanPreviewError" class="text-muted">
            <i class="fas fa-file-pdf fa-3x mb-2"></i>
            <p>Preview not available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
